import React, { useEffect } from "react";
import "../App.css";

const TermsOfUse = ({ onBack }) => {
  // Scroll handled globally

  return (
    <div className="legal-page-wrapper">
      <div className="legal-container">

        <div className="legal-header">
          <h1 className="legal-title">Terms of Use</h1>
          <span className="legal-date">Last Updated: December 2025</span>
        </div>

        <div className="legal-content">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using MoonshotMap ("the Service"), you agree to be bound by these Terms of Use. If you do not agree, you may not use the Service. MoonshotMap is a strategic visualization tool for startups and investors.
          </p>

          <h2>2. Description of Service & AI Disclaimer</h2>
          <p>
            MoonshotMap utilizes artificial intelligence to analyze data and generate strategic roadmaps. By using the Service, you acknowledge that:
          </p>
          <ul>
            <li><strong>AI Limitations:</strong> AI models can occasionally produce incorrect, biased, or "hallucinated" information. You should verify all outputs (Clarity Scores, market data, roadmaps) before making business decisions.</li>
            <li><strong>Not Professional Advice:</strong> The Service provides information, not advice. It is not a substitute for professional legal, financial, or business consulting. We are not responsible for any decisions made based on our maps or scores.</li>
          </ul>

          <h2>3. User Intellectual Property</h2>
          <p>
            <strong>You Own Your Data:</strong> You retain all right, title, and interest in and to the Strategic Inputs (pitch decks, notes) you provide to the Service. MoonshotMap claims no ownership over your startup ideas.
          </p>
          <p>
            <strong>License to Host:</strong> You grant us a limited, non-exclusive license to process your data solely for the purpose of generating your requested outputs and providing the Service to you.
          </p>

          <h2>4. Prohibited Uses</h2>
          <p>
            You agree not to use the Service to:
          </p>
          <ul>
            <li>Input sensitive personal data (PII) regarding third parties (e.g., customer lists with private emails) unless necessary and authorized.</li>
            <li>Reverse engineer, decompile, or attempt to extract the source code or proprietary algorithms of the Moonshot Engine.</li>
            <li>Use the Service to generate fraudulent or misleading business documentation.</li>
          </ul>

          <h2>5. Subscription & Billing</h2>
          <p>
            Certain features of MoonshotMap are offered under a paid subscription. All fees are non-refundable except as required by law. We reserve the right to change our pricing upon reasonable notice to you.
          </p>

          <h2>6. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, MoonshotMap and its affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or goodwill, arising from your use of the Service. Our total liability for any claim shall not exceed the amount you paid us in the past 12 months.
          </p>

          <h2>7. Termination</h2>
          <p>
            We reserve the right to suspend or terminate your access to the Service at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.
          </p>

          <h2>8. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which MoonshotMap operates, without regard to its conflict of law provisions.
          </p>

          <h2>9. Contact Information</h2>
          <p>
            Questions about the Terms of Use should be sent to us at: <a href="mailto:hello@moonshotmap.com" className="email-link">hello@moonshotmap.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;